import React, { useState, useEffect } from 'react';
import { Table, Badge } from 'react-bootstrap';

/**
 * Widget de Tabla - Muestra datos tabulares
 */
const TableWidget = ({ widget }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, [widget.type]);

  const loadData = async () => {
    // Simular carga de datos
    // TODO: Conectar con API real
    setTimeout(() => {
      if (widget.type === 'table-recent-orders') {
        setData([
          { id: 1, client: 'Ford', amount: 15000, status: 'active' },
          { id: 2, client: 'UTPL', amount: 8500, status: 'pending' },
          { id: 3, client: 'Claro', amount: 22000, status: 'active' },
          { id: 4, client: 'BMW', amount: 12000, status: 'completed' }
        ]);
      } else if (widget.type === 'table-top-campaigns') {
        setData([
          { id: 1, campaign: 'Campaña Verano', leads: 245, cpl: 12.5 },
          { id: 2, campaign: 'Black Friday', leads: 389, cpl: 8.2 },
          { id: 3, campaign: 'Navidad 2024', leads: 156, cpl: 15.8 }
        ]);
      }
      setLoading(false);
    }, 500);
  };

  if (loading) {
    return (
      <div className="text-center py-4">
        <div className="spinner-border spinner-border-sm" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  const getStatusBadge = (status) => {
    const statusMap = {
      active: 'success',
      pending: 'warning',
      completed: 'info'
    };
    return <Badge bg={statusMap[status] || 'secondary'}>{status}</Badge>;
  };

  return (
    <div className="table-widget" style={{ maxHeight: '100%', overflow: 'auto' }}>
      {widget.type === 'table-recent-orders' && (
        <Table striped hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Monto</th>
              <th>Estado</th>
            </tr>
          </thead>
          <tbody>
            {data.map(row => (
              <tr key={row.id}>
                <td>{row.client}</td>
                <td>${row.amount.toLocaleString()}</td>
                <td>{getStatusBadge(row.status)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {widget.type === 'table-top-campaigns' && (
        <Table striped hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Campaña</th>
              <th>Leads</th>
              <th>CPL</th>
            </tr>
          </thead>
          <tbody>
            {data.map(row => (
              <tr key={row.id}>
                <td>{row.campaign}</td>
                <td>{row.leads}</td>
                <td>${row.cpl}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default TableWidget;




